<section class="page_404">
	<div class="container">
		<div class="row">
			<div class="col-sm ">
				<div class=" text-center">
					<div class="four_zero_four_bg">
						<h1 class="text-center ">404</h1>


					</div>

					<div class="contant_box_404">
						<h3 class="h2">
							Parace que se encuentra perdid@
						</h3>

						<p>La página que está buscando no se encuentra disponible!.</p>
						<p>Trayecto APP © 2023</p>
						<!-- <a href="" class="link_404">Go to Home</a> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</section>